import type { IFieldAction } from '@customTypes/Common';

import styles from './styles.module.scss';

export interface ITextArea {
  label?: string;
  name: string;
  value?: string;
  placeholder?: string;
  disabled?: boolean;
  maxLength?: number;
  rows?: number;
  error?: string;
  onChange: React.ChangeEventHandler;
  onBlur?: React.FocusEventHandler;
  action?: IFieldAction;
}

const TextArea = ({ label, name, value = '', placeholder, disabled = false, maxLength = 100, rows = 3, error, onChange, onBlur, action }: ITextArea) => {
  const className = `text-input ${error ? 'text-input--error' : ''}`;

  return (
    <div className={styles.container}>
      {label && (
        <label htmlFor={name}>
          {label}
          {action && (
            <button className={styles.action} onClick={action.onClick}>
              {action.label}
            </button>
          )}
        </label>
      )}
      <div className={styles.wrapper} data-value={value}>
        <textarea
          className={className}
          name={name}
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          rows={rows}
          maxLength={maxLength}
          onBlur={onBlur}
          onChange={onChange}
        />
      </div>
      {error && <span className={styles.error}>{error}</span>}
    </div>
  );
};

export default TextArea;
